<template>
  <div class="transaction-container">
    <!-- 头部统计 -->
    <!-- <div class="stats-header">
            <div class="stat-card">
                <div class="stat-icon income">
                    <i class="fas fa-arrow-down"></i>
                </div>
                <div class="stat-info">
                    <div class="stat-label">总入账</div>
                    <div class="stat-value">${{ totalIncome }}</div>
                </div>
            </div>
            <div class="stat-card">
                <div class="stat-icon count">
                    <i class="fas fa-list"></i>
                </div>
                <div class="stat-info">
                    <div class="stat-label">交易笔数</div>
                    <div class="stat-value">{{ transactions.length }}</div>
                </div>
            </div>
            <div class="stat-card">
                <div class="stat-icon recent">
                    <i class="fas fa-clock"></i>
                </div>
                <div class="stat-info">
                    <div class="stat-label">最近交易</div>
                    <div class="stat-time">{{ latestTransaction }}</div>
                </div>
            </div>
        </div> -->

    <!-- 筛选和搜索 -->
    <!-- <div class="filter-bar">
      <div class="filter-group">
        <button v-for="filter in timeFilters" :key="filter.value" :class="['filter-btn', { active: activeTimeFilter === filter.value }]" @click="activeTimeFilter = filter.value">
          {{ filter.label }}
        </button>
      </div>
      <div class="search-box">
        <i class="fas fa-search"></i>
        <input v-model="searchQuery" type="text" :placeholder="$t('_cb._ssdz')" class="search-input" />
      </div>
    </div> -->

    <div class="transaction-section">
      <!-- <div class="section-header">
                <h3 class="section-title">存币记录</h3>
                <div class="section-actions">
                    <button v-for="sort in sortOptions" :key="sort.value"
                        :class="['sort-btn', { active: filters.sortBy === sort.value }]"
                        @click="filters.sortBy = sort.value">
                        {{ sort.label }}
                    </button>
                </div>
            </div> -->
      <!-- 交易列表 -->
      <div class="transaction-list">
        <div class="table-header">
          <div class="header-cell" style="width: 20%">{{ $t('_m._jyh') }}</div>
          <div class="header-cell" style="width: 15%">{{ $t('_m._jyje') }}</div>
          <div class="header-cell" style="width: 20%">{{ $t('_m._yhmz') }}</div>
          <div class="header-cell" style="width: 20%">{{ $t('_m._yhdz') }}</div>
          <div class="header-cell" style="width: 15%">{{ $t('_cb._sj') }}</div>
          <!-- <div class="header-cell" style="width: 10%">{{ $t('_cb._cz') }}</div> -->
        </div>

        <div v-for="transaction in filteredTransactions" :key="transaction.id" class="transaction-item">
          <div class="table-cell" style="width: 20%">
            <div class="currency-info">
              <!-- <div class="currency-icon" :class="transaction.name.toLowerCase()">
                                <i class="fab" :class="getCurrencyIcon(transaction.currency)"></i>
                            </div> -->
              <div class="currency-details">
                <div class="currency-name">{{ transaction.transfer_no }}</div>
                <!-- <div class="currency-network">{{ transaction.network }}</div> -->
              </div>
            </div>
          </div>

          <div class="table-cell" style="width: 15%">
            <div class="amount income">
              <span class="amount-symbol">+</span>
              ${{ transaction.amount }}
            </div>
          </div>

          <div class="table-cell" style="width: 20%">
            <div class="address-cell">
              <span class="address-text">{{ transaction.bank_name }}</span>
            </div>
          </div>

          <div class="table-cell" style="width: 20%">
            <div class="address-cell">
              <span class="address-text">{{ transaction.bank_account }}</span>
            </div>
          </div>

          <div class="table-cell" style="width: 15%">
            <div class="time-info">
              <div class="time-date">{{ formatDate(transaction.create_time) }}</div>
              <div class="time-hour">{{ formatTime(transaction.create_time) }}</div>
            </div>
          </div>

          <!-- <div class="table-cell" style="width: 10%">
            <div class="action-buttons">
              <button class="action-btn view-btn" @click="viewDetails(transaction)">
                <eye-outlined />
              </button>
            </div> 
          </div>-->
        </div>

        <!-- 空状态 -->
        <div v-if="filteredTransactions.length === 0" class="empty-state">
          <i class="fas fa-receipt empty-icon"></i>
          <h3>{{ $t('_cb._zwjl') }}</h3>
          <!-- <p>当前筛选条件下没有找到交易记录</p> -->
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <div class="jyjl-pagination" v-if="filteredTransactions.length > 0">
      <button class="jyjl-page-btn" :disabled="page === 1" @click="onPage(page - 1)">
        <left-outlined />
      </button>
      <span class="jyjl-page-info">{{ $t('_cb._dny', { a: page, b: totalPages }) }} </span>
      <button class="jyjl-page-btn" :disabled="page === totalPages" @click="onPage(page + 1)">
        <right-outlined />
      </button>
    </div>

    <!-- 交易详情弹窗 -->
    <div v-if="selectedTransaction" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ $t('_cb._jyxq') }}</h3>
          <button class="close-btn" @click="selectedTransaction = null">
            <CloseCircleOutlined />
          </button>
        </div>
        <div class="modal-body">
          <div class="detail-row">
            <span class="detail-label">{{ $t('_cb._jydz') }}:</span>
            <span class="detail-value">{{ selectedTransaction.address }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">{{ $t('_cb._bz') }}:</span>
            <span class="detail-value">{{ selectedTransaction.name }} ({{ selectedTransaction.network }})</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">{{ $t('_cb._je') }}:</span>
            <span class="detail-value" :class="selectedTransaction.type"> ${{ selectedTransaction.real_number }} </span>
          </div>
          <div class="detail-row">
            <span class="detail-label">{{ $t('_cb._sj') }}:</span>
            <span class="detail-value">{{ formatFullTime(selectedTransaction.create_time) }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">{{ $t('_cb._zt') }}:</span>
            <span class="status-badge confirmed">{{ $t('_cb._yqr') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RightOutlined, LeftOutlined, CloseCircleOutlined } from '@ant-design/icons-vue'
export default {
  name: 'TransactionList',
  components: {  RightOutlined, LeftOutlined, CloseCircleOutlined },
  data() {
    return {
      searchQuery: '',
      activeTimeFilter: 'all',
      selectedTransaction: null,
      timeFilters: [
        { label: this.$t('_cb._qb'), value: 'all' },
        { label: this.$t('_cb._jt'), value: 'today' },
        { label: this.$t('_cb._j7t'), value: '7days' },
        { label: this.$t('_cb._j30t'), value: '30days' }
      ],

      total: 0,
      page: 1,
      pageSize: 10,
      loading: false,
      transactions: []
    }
  },
  created() {
    // 模拟获取交易数据
    this.getBankReceiveList()
  },
  computed: {
    filteredTransactions() {
      let filtered = this.transactions.filter((transaction) => {
        const matchesSearch = this.searchQuery === '' || transaction.currency.toLowerCase().includes(this.searchQuery.toLowerCase()) || transaction.address.toLowerCase().includes(this.searchQuery.toLowerCase())

        const now = new Date()
        let timeFilter = true

        switch (this.activeTimeFilter) {
          case 'today':
            timeFilter = transaction.time.toDateString() === now.toDateString()
            break
          case '7days': {
            let sevenDaysAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000)
            timeFilter = transaction.time >= sevenDaysAgo
            break
          }
          case '30days': {
            let thirtyDaysAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000)
            timeFilter = transaction.time >= thirtyDaysAgo
            break
          }
          default:
            timeFilter = true
        }

        return matchesSearch && timeFilter
      })

      return filtered.sort((a, b) => b.time - a.time)
    },
    totalIncome() {
      return (
        this.transactions
          // .filter(t => t.type === 'income')
          .reduce((sum, t) => sum + parseFloat(t.real_number), 0)
          .toFixed(2)
      )
    },
    latestTransaction() {
      if (this.transactions.length === 0) return this.$t('_cb._zw')
      const latest = this.transactions.slice().sort((a, b) => b.create_time - a.create_time)[0]
      return this.formatTime(latest.create_time)
    },
    totalPages() {
      return Math.ceil(this.total / this.pageSize)
    }
  },
  methods: {
    onPage(page) {
      this.page = page
      this.getBankReceiveList()
    },
    getBankReceiveList() {
      let that = this
      var hide = this.$message.loading({ content: this.$t('_a._jzz'), key: 'msg' })
      this.$api.userWallet
        .getBankReceiveList({
          page: that.page,
          size: that.pageSize,
          search: ''
        })
        .then((res) => {
          hide()
          that.transactions = res.data.data
          that.total = res.data.total
        })
    },
    getCurrencyIcon(currency) {
      const icons = {
        USDT: 'fa-usd-circle',
        BTC: 'fa-btc',
        ETH: 'fa-ethereum'
      }
      return icons[currency] || 'fa-coins'
    },
    formatAddress(address) {
      if (address.length <= 16) return address
      return address.substring(0, 8) + '...' + address.substring(address.length - 8)
    },
    formatDate(date) {
      var time = new Date(date)
      return time.toLocaleDateString('zh-CN')
    },
    formatTime(date) {
      var time = new Date(date)
      return time.toLocaleTimeString('zh-CN', {
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    formatFullTime(date) {
      var time = new Date(date)
      return time.toLocaleString('zh-CN')
    },
    copyAddress(address) {
      navigator.clipboard.writeText(address).then(() => {
        this.$message.success(this.$t('_cb._fzcg'))
      })
    },
    viewDetails(transaction) {
      this.selectedTransaction = transaction
    }
  }
}
</script>

<style scoped>
@import url('../../static/css_deposit/1.css');
</style>
